// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-457b4413]{text-align:center}.amount[data-v-457b4413]{font-size:.833333rem;color:orange;font-weight:700;margin-bottom:1.041667rem}.info[data-v-457b4413]{width:80%;margin:0 auto;text-align:left}.info p[data-v-457b4413]{margin-bottom:.520833rem}.group[data-v-457b4413]{display:flex;align-items:center;justify-content:space-between}.group span[data-v-457b4413]{color:#2084d6;cursor:pointer}.el-button[data-v-457b4413]{margin-top:1.041667rem}", ""]);
// Exports
module.exports = exports;
